<template>
	<h3>Visit History Report</h3>
	<hr />
	<div class="alert alert-info" v-show="loading">Loading&hellip;</div>
  <div class="form-horizontal">
  	<div class="form-group">
	    <label for="filter" class="control-label col-sm-1"><strong>Filter:</strong></label>
	    <div class="col-sm-3">
		    <input type="text" id="filter" class="form-control" v-model="filter" placeholder="Type to Search"/>
		  </div>
	  </div>
  </div>

  <table class="table table-striped" id="visit-history-report-table">
    <thead>
      <tr>
        <th @click="setSortBy('ccs_id')">
          CCS ID
        </th>
        <th @click="setSortBy('full_name')">
          Name
        </th>
        <template v-for="(window, idx) in visitWindows" :key="'window_'+idx">
        	<th @click="setSortBy('core_visit_'+window)">Core {{ window }}</th>
        	<th @click="setSortBy('short_visit_'+window)">Short {{ window }}</th>
        </template>
      </tr>
    </thead>
    <tbody>
    	<tr v-for="part in sortedParticipants" :key="'participant_'+part.id">
    		<td><a :href="'/participants/'+part.id">{{ part.ccs_id }}</a></td>
        <td><a :href="'/participants/'+part.id">{{ part.full_name }}</a></td>
        <template v-for="(window, idx) in visitWindows" :key="'visit_'+idx">
        	<td>
        		<div v-if="part['core_visit_'+window]">
        			<strong>Core Visit {{ window }}</strong>
        			<ul class="list-unstyled">
						    <li v-if="!isFinal(part['core_visit_'+window])">
						    	<a :href="visitLink(part['core_visit_'+window])">{{ part['core_visit_'+window]['status'] }}</a>
						    </li>
						    <li v-else>{{ part['core_visit_'+window]['status'] }}</li>
						    <li>{{ part['core_visit_'+window]['date'] }}</li>
							</ul>
        		</div>
        	</td>
        	<td>
        		<div v-if="part['short_visit_'+window]">
        			<strong>Short Visit {{ window }}</strong>
        			<ul class="list-unstyled">
						    <li v-if="!isFinal(part['short_visit_'+window])">
						    	<a :href="visitLink(part['short_visit_'+window])">{{ part['short_visit_'+window]['status'] }}</a>
						    </li>
						    <li v-else>{{ part['short_visit_'+window]['status'] }}</li>
						    <li>{{ part['short_visit_'+window]['date'] }}</li>
							</ul>
        		</div>
        </td>
        </template>
    	</tr>
    </tbody>
  </table>
</template>

<script setup>
	import { ref, computed, onMounted } from 'vue'

	const props = defineProps(['visitWindows'])
	const filter = ref('')
	const participants = ref([])
	const loading = ref(true)
	const sortBy = ref('ccs_id')
	const sortDir = ref('asc')

  function setSortBy(val) {
    sortBy.value = val
    sortDir.value = sortDir.value == 'asc' ? 'desc' : 'asc'
  }

	function isAppointmentOfStatus(data, status) {
		return data.type == 'appointment' && data.status == status
	}

	function isTaskOfStatus(data, status) {
		return data.type == 'task' && data.status == status
	}

	function visitLink(data) {
		let url = data.type == 'appointment' ? '/appointments/' : '/tasks/'
		return url + data.id
	}

	function isFinal(data) {
		return isAppointmentOfStatus(data, 'Attended') 
			|| isAppointmentOfStatus(data, 'Auto Canceled') 
			|| isTaskOfStatus(data, 'Auto Canceled') 
			|| isTaskOfStatus(data, 'Canceled')
	}

	function fetchParticipants() {
    axios.get('/api/visit-history-report')
      .then( (response) => {
      	loading.value = false
        participants.value  = response.data.data
      })
      .catch( (e) => {
          console.log("Error: VisitHistoryReportTable.vue, fetchParticipants(), "+ e.message)
      })
  }

  const sortedParticipants = computed(() => {  	
    var filterFunc = function (participant) {
      var re = new RegExp(filter.value, 'i');
      if (filter.value && filter.value.length > 1) {
        return (participant.full_name.search(re) != -1
            || participant.id == filter
            || participant.ccs_id.search(re) != -1);
      } else {
        return true
      }
    }.bind(this);

  	let direction = sortDir.value == 'asc' ?  1 : -1;
    return participants.value.filter(filterFunc)
        .sort(function (a, b) {
            switch (sortBy.value) {
              case ('ccs_id'):
              case ('full_name'):
                if (a[sortBy.value] > b[sortBy.value]) return 1 * direction;
                if (a[sortBy.value] < b[sortBy.value]) return -1 * direction;
                return 0;
                break;
              default: 
              	if (a[sortBy.value]==null) return -1 * direction;
              	if (b[sortBy.value]==null) return 1 * direction;
                if (a[sortBy.value]['raw_date'] > b[sortBy.value]['raw_date']) return 1 * direction;
                if (a[sortBy.value]['raw_date'] < b[sortBy.value]['raw_date']) return -1 * direction;
                return 0;
              }
          }.bind(this));
  })

	onMounted(() => {
		fetchParticipants()
	})
</script>

<style scoped>
	th {
		cursor: pointer;
	}
</style>